import { FetchStatus } from 'types/api';

export const useFormLoading = (statuses: Array<FetchStatus>): { isLoading: boolean } => {
    return { isLoading: statuses.some((status) => status === FetchStatus.FETCHING) };
};
